<template>
  <v-dialog v-model="dialog" persistent max-width="30%">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="toolbar-color">
          <span class="headline ml-2">
            {{ labelBtn != "Salvar" ? "Editar Grupo Comissão" : "Cadastrar " }}
          </span>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col v-if="labelBtn == 'Salvar'">
              <v-text-field
                label="ID"
                v-model="form.id_grupo_comissao"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field
                label="Grupo Comissão"
                v-model="form.descricao"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col v-if="labelBtn == 'Salvar'">
              <v-text-field
                label="Descrição"
                v-model="form.apelido"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Fechar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="labelBtn != 'Salvar' ? editar() : cadastrar()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/inputRules";
import comissao from "@/services/http/comissaoService";
export default {
  name: "ModalGrupoComissao",

  mixins: [rules],
  components: {},

  props: {
    dialog: {
      type: Boolean
    },

    labelBtn: {
      type: String
    },

    grupoComissao: {
      type: Object
    }
  },

  data() {
    return {
      form: {}
    };
  },

  watch: {
    grupoComissao() {
      if (this.grupoComissao) {
        this.form = this.grupoComissao;
      }
    }
  },

  methods: {
    async cadastrar() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await comissao()
          .grupoComissao()
          .store(this.form, {
            notification: true,
            message: "Grupo Comissão cadastrada com sucesso!"
          }),
          this.close();
      }
    },

    async editar() {
      const validateStatus = this.$refs.form.validate();
      if (validateStatus) {
        await comissao()
          .grupoComissao(this.form.id_grupo_comissao)
          .update(this.form, {
            notification: true,
            message: "Grupo Comissão editado com sucesso!"
          }),
          this.close();
      }
    },

    close() {
      this.$emit("close");
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
